<template>
  <div class="banner-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="search-box">
          <div class="search-right">
            <div class="search-item">
              <div class="title">设置查询条件</div>
              <div class="group-info">
                <div
                  class="info-item"
                  v-for="(item, index) in list"
                  :class="{ date: item.type === 'date' }"
                >
                  <div class="label">{{ item.label }}</div>
                  <!-- <el-checkbox v-model="item.checked">{{
                      item.label
                    }}</el-checkbox> -->
                  <div
                    v-if="item.type === 'list'"
                    class="info-right"
                    style="align-items: flex-start;"
                  >
                    <el-radio-group
                      v-model="item.checked"
                      style="margin-right: 6px;flex-shrink: 0;margin-top: 6px;"
                    >
                      <el-radio aria-hidden="true" :label="0"
                        >暂不查询</el-radio
                      >
                      <el-radio aria-hidden="true" :label="-1">不限</el-radio>
                      <el-radio aria-hidden="true" :label="1">多选</el-radio>
                    </el-radio-group>
                    <el-checkbox-group
                      v-model="item.checkList"
                      style="margin-left: 20px;"
                    >
                      <el-checkbox
                        :label="option.id"
                        v-for="(option, optionIndex) in optionObj[
                          item.optionName
                        ]"
                        :key="optionIndex"
                        >{{ option.labelName }}</el-checkbox
                      >
                    </el-checkbox-group>
                  </div>
                  <div class="info-right" v-if="item.type === 'date'">
                    <el-date-picker
                      size="mini"
                      class="date-input"
                      v-model="item.checkList"
                      type="datetimerange"
                      align="right"
                      unlink-panels
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd hh:mm:ss"
                    >
                    </el-date-picker>
                  </div>
                  <div class="info-right" v-if="item.type === 'range'">
                    <el-radio-group
                      v-model="item.checked"
                      style="margin-right: 6px;"
                    >
                      <el-radio aria-hidden="true" :label="0"
                        >暂不查询</el-radio
                      >
                      <el-radio aria-hidden="true" :label="-1">不限</el-radio>
                      <el-radio aria-hidden="true" :label="1"
                        >多选价格</el-radio
                      >
                    </el-radio-group>
                    <el-select
                      v-model="item.checkList[0]"
                      style="width: 100px;margin-right: 10px;"
                      size="mini"
                      placeholder="请选择"
                      class="select"
                    >
                      <el-option label="小于" :value="1"> </el-option>
                      <el-option label="等于" :value="2"> </el-option>
                      <el-option label="大于" :value="3"> </el-option>
                      <el-option label="介于" :value="4"> </el-option>
                    </el-select>
                    <el-input
                      v-model="item.checkList[1]"
                      size="mini"
                      class="range-input"
                    ></el-input>
                    <div
                      style="margin: 0 5px;color: #999;"
                      v-if="item.checkList[0] === 4"
                    >
                      至
                    </div>
                    <el-input
                      v-model="item.checkList[2]"
                      v-if="item.checkList[0] === 4"
                      size="mini"
                      class="range-input"
                    ></el-input>
                  </div>
                  <div class="info-right" v-if="item.type === 'product'">
                    <el-radio-group
                      v-model="item.checked"
                      style="margin-right: 6px;"
                    >
                      <el-radio aria-hidden="true" :label="0"
                        >暂不查询</el-radio
                      >
                      <el-radio aria-hidden="true" :label="-1">不限</el-radio>
                      <el-radio aria-hidden="true" :label="1"
                        >多选产品</el-radio
                      >
                    </el-radio-group>
                    <div class="select-box" @click="selectProductModal(item)">
                      <div>
                        <span v-if="item.checkList.length">
                          已选{{ item.checkList.length }}种产品
                        </span>
                        <span v-else>
                          请选择产品
                        </span>
                      </div>
                      <div class="add">
                        选择产品
                      </div>
                    </div>
                  </div>
                  <div class="info-right" v-if="item.type === 'brand'">
                    <el-radio-group
                      v-model="item.checked"
                      style="margin-right: 6px;"
                    >
                      <el-radio aria-hidden="true" :label="0"
                        >暂不查询</el-radio
                      >
                      <el-radio :label="-1">不限</el-radio>
                      <el-radio :label="1">多选品牌</el-radio>
                    </el-radio-group>
                    <div class="select-box" @click="selectBrandModal(item)">
                      <div>
                        <span v-if="item.checkList.length">
                          已选{{ item.checkList.length }}种品牌
                        </span>
                        <span v-else>
                          请选择品牌
                        </span>
                      </div>
                      <div class="add">
                        选择品牌
                      </div>
                    </div>
                  </div>
                  <div class="info-right" v-if="item.type === 'category'">
                    <el-radio-group
                      v-model="item.checked"
                      style="margin-right: 6px;"
                    >
                      <el-radio aria-hidden="true" :label="0"
                        >暂不查询</el-radio
                      >
                      <el-radio aria-hidden="true" :label="-1">不限</el-radio>
                      <el-radio aria-hidden="true" :label="1"
                        >多选产品</el-radio
                      >
                    </el-radio-group>
                    <div class="select-box" @click="selectCategoryModal(item)">
                      <div>
                        <span v-if="item.checkList.length">
                          已选{{ item.checkList.length }}种分类
                        </span>
                        <span v-else>
                          请选择分类
                        </span>
                      </div>
                      <div class="add">
                        选择分类
                      </div>
                    </div>
                  </div>
                  <div class="info-right" v-if="!item.type">
                    <el-radio-group
                      v-model="item.checked"
                      style="margin-right: 6px;"
                    >
                      <el-radio aria-hidden="true" :label="0"
                        >暂不查询</el-radio
                      >
                      <el-radio :label="-1">不限</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="btn-box">
                  <div class="btn" @click="handleConfirm">查询</div>
                </div>
              </div>
              <div class="title">点击数据-查询结果</div>
              <div class="result-box">
                <div
                  class="result-item"
                  v-for="item in list"
                  :key="item.name"
                  v-if="item.name !== 'created'"
                >
                  <div v-if="resultArr[item.name] === -1">未查询</div>
                  <div v-else>{{ resultArr[item.name] }}</div>
                  {{ item.label }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="page-btn-box">
          <button class="cancel-btn" @click="handleCancel">取消</button>
          <button class="confirm-btn" @click="handleConfirm">保存</button>
        </div> -->
      </div>
    </div>
    <el-dialog
      :visible.sync="selectProductVisible"
      class="dialog"
      width="1150px"
      top="10vh"
    >
      <div slot="title" class="dialog-title">
        多选产品
      </div>
      <div class="select-product-box">
        <div class="filter-box">
          <div class="label" style="margin-left: 0;">产品ID：</div>
          <el-input
            v-model="productForm.id"
            placeholder="产品ID"
            style="width: 120px;"
            size="small"
          ></el-input>
          <div class="label">关键字：</div>
          <el-input
            v-model="productForm.name"
            placeholder="关键字"
            style="width: 200px;"
            size="small"
          ></el-input>
          <div class="label">价格：</div>
          <el-input
            v-model="productForm.minPrice"
            placeholder=""
            style="width: 80px;"
            size="small"
          ></el-input>
          <div style="margin: 0 5px;">至</div>
          <el-input
            v-model="productForm.maxPrice"
            placeholder=""
            style="width: 80px;"
            size="small"
          ></el-input>
          <div style="margin: 0 5px;">元</div>
          <div class="search" @click="getGoodsList">搜索</div>
          <div class="reset" @click="resetProduct">重置</div>
        </div>
        <div class="product-list-box">
          <div class="list-left">
            <div class="list-top">
              <el-checkbox
                v-model="selectAll"
                style="margin-right: 6px;"
                @change="handleChangeAll"
              ></el-checkbox>
              选中当前页
            </div>
            <div class="product-list" :key="timeStemp">
              <div
                class="item"
                v-for="(item, index) in productList"
                :key="index"
              >
                <el-checkbox
                  :value="selectedObj[item.id]"
                  @change="(e) => changeSelected(e, item)"
                ></el-checkbox>
                <img :src="item.masterPic" alt="" class="pic" />
                <div class="product-info">
                  <div class="name">{{ item.name }}</div>
                  <div class="id">产品ID：{{ item.id }}</div>
                </div>
                <div class="price">￥{{ item.price }}</div>
              </div>
            </div>
            <div class="pagination" v-show="productList.length">
              <el-pagination
                @current-change="handleCurrentChangeProduct"
                :current-page.sync="currentPage"
                background
                layout="total, prev, pager, next, jumper"
                :page-size="size"
                :total="total"
                small
              ></el-pagination>
            </div>
          </div>
          <div style="width: 40px;text-align: center;color: #999;">>></div>
          <div class="list-right">
            <div class="list-top">
              已选择产品（{{ selectProductList.length }}）
              <span @click="emptyProduct">清空</span>
            </div>
            <div class="product-list">
              <div
                class="item"
                v-for="(item, index) in selectProductList"
                :key="index"
              >
                {{ index + 1 }}
                <img :src="item.masterPic" alt="" class="pic" />
                <div class="product-info">
                  <div class="name">{{ item.name }}</div>
                  <div class="id">产品ID：{{ item.id }}</div>
                </div>
                <div class="price">￥{{ item.price }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="selectProductVisible = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="addProduct">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="selectBrandVisible"
      class="dialog"
      width="1150px"
      top="10vh"
    >
      <div slot="title" class="dialog-title">
        多选品牌
      </div>
      <div class="select-product-box">
        <div class="filter-box">
          <div class="label" style="margin-left: 0;">品牌ID：</div>
          <el-input
            v-model="brandForm.id"
            placeholder="品牌ID"
            style="width: 120px;"
            size="small"
          ></el-input>
          <div class="label">关键字：</div>
          <el-input
            v-model="brandForm.brandName"
            placeholder="关键字"
            style="width: 200px;"
            size="small"
          ></el-input>
          <div style="margin: 0 5px;">元</div>
          <div class="search" @click="getBrandList">搜索</div>
          <div class="reset" @click="resetBrand">重置</div>
        </div>
        <div class="product-list-box">
          <div class="list-left">
            <div class="list-top">
              <el-checkbox
                v-model="selectAll"
                style="margin-right: 6px;"
                @change="handleChangeAll"
              ></el-checkbox>
              选中当前页
            </div>
            <div class="product-list" :key="timeStemp">
              <div class="item" v-for="(item, index) in brandList" :key="index">
                <!-- {{ selectedObj[item.id] }} -->
                <el-checkbox
                  :value="selectedObj[item.id]"
                  @change="(e) => changeSelected(e, item)"
                ></el-checkbox>
                <img :src="item.logo" alt="" class="pic" />
                <div class="product-info">
                  <div class="name">{{ item.brandName }}</div>
                  <div class="id">品牌ID：{{ item.id }}</div>
                </div>
                <!-- <div class="price">￥{{ item.price }}</div> -->
              </div>
            </div>
            <div class="pagination" v-show="brandList.length">
              <el-pagination
                @current-change="handleCurrentChangeBrand"
                :current-page.sync="currentPage"
                background
                layout="total, prev, pager, next, jumper"
                :page-size="size"
                :total="total"
                small
              ></el-pagination>
            </div>
          </div>
          <div style="width: 40px;text-align: center;color: #999;">>></div>
          <div class="list-right">
            <div class="list-top">
              已选择品牌（{{ selectBrandList.length }}）
              <span @click="emptyBrand">清空</span>
            </div>
            <div class="product-list">
              <div
                class="item"
                v-for="(item, index) in selectBrandList"
                :key="index"
              >
                {{ index + 1 }}
                <img :src="item.logo" alt="" class="pic" />
                <div class="product-info">
                  <div class="name">{{ item.brandName }}</div>
                  <div class="id">品牌ID：{{ item.id }}</div>
                </div>
                <!-- <div class="price">￥{{ item.price }}</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="selectBrandVisible = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="addBrand">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="selectCategoryVisible"
      class="dialog"
      width="360px"
      top="20vh"
    >
      <div slot="title" class="dialog-title">
        多选分类
      </div>
      <div
        style="padding-top: 10px;padding-bottom: 20px;max-height: 300px;overflow-y: auto;"
      >
        <el-tree
          :data="categoryList"
          show-checkbox
          node-key="id"
          ref="tree"
          :key="categoryTimeStemp"
          :default-checked-keys="categoryIds"
          @check-change="handleCheckChange"
          :props="defaultProps"
        >
        </el-tree>
        <el-tree
          :data="ageList"
          show-checkbox
          node-key="id"
          ref="ageTree"
          :key="categoryTimeStemp + 1"
          :default-checked-keys="ages"
          @check-change="handleCheckChange"
          :props="defaultProps"
        >
        </el-tree>
        <div class="price-box" style="display: flex;justify-content: flex-start;align-items: center;margin-top: 10px;">
          <div style="width: 50px;">价格</div>
          <el-input v-model="prices[0]" placeholder="最低价格" style="width: 100px;margin-right: 6px;" size="small"></el-input>
          <el-input v-model="prices[1]" placeholder="最高价格" style="width: 100px;" size="small"></el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="selectCategoryVisible = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="addCategory"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'banner',
  data() {
    return {
      loading: 0, // 加载中
      currentPage: 1, // 当前页码
      size: 6, // 每页条数
      total: 0, // 总页数
      title: {
        // 页面标题
        firstTitile: '用户管理',
        secondTitle: '平台点击数据查询'
      },
      selectProductVisible: false,
      productList: [], // 已选产品列表
      selectProductList: [],
      selectBrandVisible: false,
      brandList: [],
      selectBrandList: [],
      selectAll: false,
      selectedObj: {},
      productForm: {
        minPrice: null,
        maxPrice: null,
        name: '',
        id: null
      },
      brandForm: {
        id: null,
        brandName: ''
      },
      selectCategoryVisible: false,
      defaultProps: {
          children: 'labelDetail',
          label: 'labelName'
      },
      categoryList: [],
      categoryTimeStemp: +new Date(),
      timeStemp: +new Date(),
      currentItem: null,
      optionObj: {
        age: [],
      },
      categoryIds: [],
      list: [
        {
          name: 'evaluating',
          label: '评测',
          checkList: [],
          checked: 0,
          type: 'product'
        },
        {
          name: 'milkKnowProduct',
          label: '奶粉知道产品',
          checkList: [],
          checked: 0,
          type: 'product'
        },
        {
          name: 'milkKnowBrand',
          label: '奶粉知道品牌',
          checkList: [],
          checked: 0,
          type: 'brand'
        },
        {
          name: 'informationProduct',
          label: '资讯产品',
          checkList: [],
          checked: 0,
          type: 'product'
        },
        {
          name: 'informationBrand',
          label: '资讯品牌',
          checkList: [],
          checked: 0,
          type: 'brand'
        },
        {
          name: 'productId',
          label: '产品',
          checkList: [],
          checked: 0,
          type: 'product'
        },
        {
          name: 'brandId',
          label: '品牌',
          checkList: [],
          checked: 0,
          type: 'brand'
        },
        {
          name: 'banner',
          label: '轮播',
          checkList: [],
          checked: 0,
        },
        {
          name: 'classify',
          label: '分类',
          checkList: [],
          checked: 0,
          type: 'category'
        },
        // {
        //   name: 'age',
        //   label: '年龄',
        //   checkList: [],
        //   checked: false,
        //   type: 'list',
        //   optionName: 'age',
        //   checked: 0,
        // },
        // {
        //   name: 'price',
        //   label: '价格',
        //   checkList: [],
        //   checked: false,
        //   type: 'range',
        //   checked: 0,
        // },
        {
          name: 'contrast',
          label: '对比',
          checkList: [],
          checked: 0,
          type: 'product'
        },
        {
          name: 'consult',
          label: '咨询',
          checkList: [],
          checked: 0,
          type: 'product'
        },
        {
          name: 'lofting',
          label: '派样',
          checkList: [],
          checked: 0,
          type: 'product'
        },
        {
          name: 'created',
          label: '时间节点',
          checkList: [],
          checked: 1,
          type: 'date'
        },
      ],
      ageList: [],
      ages: [],
      prices: [null, null],
      resultArr: []
    };
  },
  async mounted() {
    // 获取列表
    // this.getLabelItem();
    await this.getLabelItemByName('age');
    this.getCategoryList();
  },
  computed: {},
  methods: {
    getCategoryList() {
      this.loading++;
      this.httpGet(this.$root.getFilterLabel).then(
        res => {
          this.loading--;
          this.categoryList = res.list.map(item => {
            return {
              ...item,
              id: item.id * 100000,
              labelName: item.name
            }
          });
        },
        err => {
          this.loading--;
          console.log(err);
        }
      )
    },
    getLabelItem(){
      this.getLabelItemByName('age');
    },
    getLabelItemByName(dataName){
      this.loading++;
      return this.httpGet(this.$root.getLabelItem, {
        dataName
      }).then(
        (res) => {
          this.loading--;
          if(dataName === 'role'){
            res.forEach(item => {
              item.id = item.labelName;
            });
          }
          this.optionObj[dataName] = res;
          this.ageList = [
            {
              dataName: 'age',
              labelName: '年龄',
              labelDetail: this.optionObj.age || []
            }
          ]
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    handleCurrentChangeProduct(page){
      this.currentPage = page;
      this.getGoodsList();
    },
    handleCurrentChangeBrand(page){
      this.currentPage = page;
      this.getBrandList();
    },
    getGoodsList() {
      // this.loading++;
      this.httpGet(this.$root.getGoodsList, {
        page: this.currentPage,
        size: this.size,
        ...this.productForm,
        minPrice: +this.productForm.minPrice || null,
        maxPrice: +this.productForm.maxPrice || null,
        id: +this.productForm.id || null,
      }).then(
        (res) => {
          // this.loading--;
          this.productList = res.list;
          this.total = res.total;
          this.timeStemp = +new Date();
          let flag = true;
          res.list.forEach(item => {
            if(!this.selectedObj[item.id]) flag = false;
          });
          this.selectAll = flag;
        },
        (res) => {
          // this.loading--;
          this.$message.error(res);
        }
      );
    },
    resetProduct(){
      this.productForm = {
        id: null,
        name: '',
        minPrice: null,
        maxPrice: null
      };
      this.getGoodsList();
    },
    getBrandList() {
      // this.loading++;
      this.httpGet(this.$root.getBrandList, {
        page: this.currentPage,
        size: this.size,
        ...this.brandForm,
        id: +this.brandForm.id || null,
      }).then(
        (res) => {
          // this.loading--;
          this.brandList = res.list;
          this.total = res.total;
          this.timeStemp = +new Date();
        },
        (res) => {
          // this.loading--;
          this.$message.error(res);
        }
      );
    },
    resetBrand(){
      this.brandForm = {
        id: null,
        brandName: '',
      };
      this.getGoodsList();
    },
    handleChangeLeft(e, group){
      // console.log(e, group);
      if(e) {
        group.isSelect = true;
        group.selectNum++;
      } else {
        group.selectNum--;
        if(group.selectNum <= 0) (group.isSelect = false);
      }
    },
    changeSelected(e, item){
      // console.log(e, item);
      if(this.selectProductVisible){
        this.selectedObj[item.id] = e;
        if(e) this.selectProductList.push(item);
        if(!e){
          this.selectProductList = this.selectProductList.filter(product => {
            return product.id !== item.id;
          });
        };
        let flag = true;
        this.productList.forEach(product => {
          if(!this.selectedObj[product.id]) flag = false;
        });
        this.selectAll = flag;
      };
      if(this.selectBrandVisible){
        this.selectedObj[item.id] = e;
        if(e) this.selectBrandList.push(item);
        if(!e){
          this.selectBrandList = this.selectBrandList.filter(brand => {
            return brand.id !== item.id;
          });
        };
        let flag = true;
        this.brandList.forEach(brand => {
          if(!this.selectedObj[brand.id]) flag = false;
        });
        this.selectAll = flag;
      }
    },
    handleChangeAll(e){
      if(e){
        if(this.selectProductVisible){
          this.productList.forEach(item => {
            if(!this.selectedObj[item.id]) this.selectProductList.push(item);
            this.selectedObj[item.id] = true;
          });
        };
        if(this.selectBrandVisible){
          this.brandList.forEach(item => {
            if(!this.selectedObj[item.id]) this.selectBrandList.push(item);
            this.selectedObj[item.id] = true;
          });
        };
      } else {
        if(this.selectProductVisible){
          this.productList.forEach(item => {
            // this.selectProductList.push(item);
            this.selectedObj[item.id] = false;
          });
          this.selectProductList = this.selectProductList.filter(item => {
            return this.selectedObj[item.id];
          })
        };
        if(this.selectBrandVisible){
          this.brandList.forEach(item => {
            // this.selectProductList.push(item);
            this.selectedObj[item.id] = false;
          });
          this.selectBrandList = this.selectBrandList.filter(item => {
            return this.selectedObj[item.id];
          })
        }
      }
    },
    async selectProductModal(item){
      this.currentItem = item;
      this.selectedObj = {};
      this.currentPage = 1;
      this.selectProductList = [];
      this.selectProductList = [...item.checkList];


      this.getGoodsList();
      this.selectProductVisible = true;
    },
    // getProductInfoByIds(ids){
    //   this.selectProductList = [{id: 3050, name: '123'}];
    //   // this.selectedObj
    // },
    emptyProduct(){
      this.selectProductList = [];
      this.selectedObj = {};
    },
    addProduct(){
      this.selectProductVisible = false;
      if(this.currentItem){
        this.currentItem.checkList = [...this.selectProductList];
        this.currentItem.load = true;
        this.currentItem.checked = 1;
      }
    },
    async selectBrandModal(item){
      this.currentItem = item;
      this.selectedObj = {};
      this.currentPage = 1;
      this.selectBrandList = [];
      this.selectBrandList = [...item.checkList];
      this.getBrandList();
      this.selectBrandVisible = true;
    },
    // getBrandInfoByIds(ids){
    //   // this.selectedObj
    // },
    emptyBrand(){
      this.selectBrandList = [];
      this.selectedObj = {};
    },
    addBrand(){
      this.selectBrandVisible = false;
      if(this.currentItem){
        this.currentItem.checkList = [...this.selectBrandList];
        this.currentItem.load = true;
        this.currentItem.checked = 1;
      }
    },
    selectCategoryModal(item){
        this.currentItem = item;
        this.categoryTimeStemp = +new Date();
        this.categoryIds = item.checkList;
        this.selectCategoryVisible = true;
    },
    handleCheckChange(target, checked, has){
        // console.log(target, checked, has);
        // if(!target.fid){
        // }
      // const checkedNodes = this.$refs.tree.getCheckedNodes();
      // let checkedSecond = checkedNodes.filter(item => item.fid);

      // console.log("当前所有选中的节点：", checkedSecond);
    },
    addCategory(){
      this.selectCategoryVisible = false;
      if(this.currentItem){
        const checkedNodes = this.$refs.tree.getCheckedNodes();
        let checkedSecond = checkedNodes.filter(item => item.fid);
        // console.log("当前所有选中的节点：", checkedSecond);
        this.currentItem.checkList = checkedSecond.map(item => item.id);
        this.currentItem.checked = 1;
        // this.currentItem.checkList = [...this.selectBrandList];
        // this.currentItem.load = true;

        const checkedAgeNodes = this.$refs.ageTree.getCheckedNodes();
        let checkedAge = checkedAgeNodes.filter(item => item.id);
        this.ages = checkedAge.map(item => item.id);
      }
    },
    handleConfirm(){
    //   console.log(this.groupList);
      let obj = {};
      this.list.forEach(item => {
        if(item.type === 'range'){
            // item.checkList[1] = +item.checkList[1] || null;
            // item.checkList[2] = +item.checkList[2] || null;
            if(item.checkList[0] === 4){
                item.checkList = [4, +item.checkList[1] || null, +item.checkList[2] || null];
            } else {
                item.checkList = [+item.checkList[0], +item.checkList[1] || null];
            }
            obj[item.name] = item.checkList;
        } else if((item.type === 'product' || item.type === 'brand')){
            if(item.load){
                obj[item.name] = item.checkList.map(i => i.id);
            } else {
                obj[item.name] = item.checkList;
            }
        } else if (item.type === 'category') {
          obj.age = this.ages;
          obj.price = [+this.prices[0], +this.prices[1]];
          if(item.checked === -1){
            obj.age = [-1];
            obj.price = [-1];
          }
          if(item.checked === 0){
            obj.age = [];
            obj.price = [];
          }
        } else {
            if(item.checked){
                obj[item.name] = item.checkList;
            }
        }
        if(item.checked === -1){
            obj[item.name] = [-1];
        }
        if(item.checked === 0){
            obj[item.name] = [];
        }
    });
    //   console.log(obj);
    //   return;
      // addPortraitSearch
      this.loading++;
      this.httpPost(this.$root.portraitClickList, {
        ...obj
      }).then(
        (res) => {
          this.loading--;
          this.resultArr = res.list;
        //   this.handleCancel();
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    //   console.log(obj);
    },
    handleCancel() {
      this.$router.push({ name: 'portraitData' });
    },
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';
>>>.el-radio input[aria-hidden='true']{
    display: none !important;
}

>>>.el-radio__original{
    display: none !important;
}

>>>.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
    box-shadow: none !important;
}

.banner-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;
  background: #F6F6F6;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    // padding: 0 20px 20px;
    background: #F6F6F6;


    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      // background: white;
      box-sizing: border-box;
      padding: 0 12px 100px;
      border-radius: 2px;
      flex-y(flex-start, flex-start);
      .title-box{
        width: 100%;
        height: 64px;
        padding: 0 24px;
        box-sizing: border-box;
        flex-x(flex-start);
        background: #fff;
        border-radius: 5px;
        .label{
          margin-right: 16px;
          white-space: nowrap;
          word(16px, #333);
        }
        .input{
          width: 400px;
          margin-right: 120px;
        }
        .select{
          width: 160px;
        }
      }
      .search-box{
        flex: 1;
        width: 100%;
        flex-x(flex-start, flex-start);
        // margin-top: 6px;

        .search-left{
          width: 230px;
          border-radius: 5px;
          overflow: hidden;
          margin-right: 5px;

          .search-item{
            width: 230px;
            margin-bottom: 1px;
            padding: 0 12px 14px;
            // padding:
            background: #fff;
            box-sizing: border-box;
            .title{
              height: 32px;
              flex-x(flex-start);
              word(24px, #333);
              // padding: 0 14px;
              box-sizing: border-box;

            }
            .group-info{
              width: 100%;
              background: #F5F5F5;
              border-radius: 2px;
              padding: 10px;
              box-sizing: border-box;
              .info-item{
                height: 32px;
                flex-x(flex-start);
                word(14px, #333);
              }
            }
          }
        }
        .search-right{
          flex: 1;
          .search-item{
            border-radius: 5px;
            margin-top: 5px;
            overflow: hidden;
            .title{
              height: 40px;
              background: #fff;
              flex-x(flex-start);
              padding-left: 24px;
              word(18px, #333);
            }
            .group-info{
              background: #fff;
              padding-bottom: 16px;
              .info-item{
                min-height: 40px;
                flex-x(flex-start, flex-start);
                padding-left: 40px;
                &.date{
                    border-top: 1px solid #EDEDED;
                    padding-top: 16px;
                }
                .label{
                  width: 100px;
                  line-height: 40px;
                  text-align: right;
                  word(14px, #333);
                }
                .info-right{
                  padding: 6px;
                  padding-left: 24px;
                  min-height: 40px;
                  box-sizing: border-box;
                  flex: 1;
                  flex-x(flex-start);
                  .range-input{
                    width: 100px;
                  }
                  .select-box{
                    width: 300px;
                    height: 24px;
                    background: #F2F2F2;
                    border: 1px solid #E3E3E3;
                    border-radius: 2px;
                    flex-x();
                    padding: 0 10px;
                    box-sizing: border-box;
                    span{
                      word(14px, #333);
                    }
                    .add{
                      word(14px, #618EFF);
                      cursor: pointer;
                    }
                  }
                }
              }
              .btn-box{
                padding-left: 164px;
                .btn{
                    width: 96px;
                    height: 28px;
                    background: #5283FF;
                    border-radius: 4px;
                    word(14px, #fff);
                    flex-x(center);
                    cursor: pointer;
                }
              }
            }
          }
        }
      }
      .result-box{
        height: 120px;
        background: #fff;
        flex-x();
        .result-item{
            flex: 1;
            flex-y();
            word(14px, #666);
            div{
                word(24px, #333);
                font-weight: 600;
                margin-bottom: 16px;
            }
        }
      }
    }
  }
  .select-product-box{
    .filter-box{
      flex-x(flex-start);
      .label{
        margin-right: 16px;
        margin-left: 12px;
      }
      .search{
        width: 65px;
        height: 36px;
        border-radius: 5px;
        background: #5283FF;
        border: 1px solid #5283FF;
        box-siing: border-box;
        word(14px, #fff);
        flex-x(center);
        cursor: pointer;
        margin-left: 24px;
      }
      .reset{
        width: 65px;
        height: 36px;
        border-radius: 5px;
        background: #fff;
        border: 1px solid #979797;
        box-siing: border-box;
        word(14px, #333);
        flex-x(center);
        cursor: pointer;
        margin-left: 12px;

      }
    }
    .product-list-box{
      flex-x();
      margin-top: 20px;
      margin-bottom: 20px;
      .list-left, .list-right{
        width: 550px;
        height: 480px;
        background: #F2F2F2;
        border: 1px solid #E8E8E8;
        .list-top{
          height: 32px;
          flex-x(flex-start);
          padding: 0 12px;
          box-sizing: border-box;
          border-bottom: 1px solid #E8E8E8;
          span{
            cursor: pointer;
          }
        }
        &.list-right{
          .list-top{
            width: 100%;
            flex-x();
          }
        }
        .product-list{
          flex-y(flex-start);
          padding: 0 12px;
          .item{
            width: 100%;
            height: 65px;
            flex-x(flex-start);
            border-bottom: 1px dashed #D1D1D1;
            .pic{
              width: 44px;
              height: 44px;
              border-radius: 2px;
              margin-left: 10px;
              margin-right: 5px;
            }
            .product-info{
              flex: 1;
              height: 36px;
              flex-y(space-between, flex-start);
            }
            .price{
              height: 36px;
              word(14px, #FF8D1A);
              flex-y(flex-end, flex-start);
            }
          }
        }
        .pagination{
          width: 100%;
          height: 36px;
          flex-x(flex-end);
          margin-top: 10px;
        }
      }
      .list-right{
        overflow-y: auto;
      }
    }
  }
  .page-btn-box {
    background: white;
    width: calc(100% - 224px);
    flex-x(center);
    height: 80px !important;
    flex-shrink: 0;
    position: fixed;
    bottom: 0;
    z-index: 100;
    // padding-bottom: 48px;

    .cancel-btn {
      width: 96px;
      height: 40px;
      cancel-btn();
      // border-radius: 23px;
    }

    .confirm-btn {
      width: 96px;
      height: 40px;
      margin-left: 20px;
      confirm-btn();
    }
  }
}
</style>
